module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan3-1-5b94402e26dc996405b71ac29dfbb8af.webp";